import { defineMessages } from "react-intl";

const messages = defineMessages({
  scheduleDetailsTitle: {
    defaultMessage: "{origin} to {destination}",
    id: "scheduleDetails.title",
    description: "The title shown above a schedule",
  },
  findTickets: {
    defaultMessage: "Find tickets",
    id: "scheduleDetails.findTickets",
    description: "Text on the button that finds tickets",
  },
  confirmButton: {
    id: "calendarConfirmation.confirmButton",
    description: "Text for button to submit search for date and time",
    defaultMessage: "Confirm",
  },
  selectDatesCta: {
    id: "segmentScreen.mobileCta",
    defaultMessage: "Select Dates",
    description:
      "Text on a button that opens the segment pane date picker on mobile",
  },
  multipartTrip: {
    id: "scheduleDetails.multipartTrip",
    defaultMessage: "Multipart trip",
    description:
      "Text over the trip itinerary title that informs the user that this is a multipart trip",
  },
  connectedTrip: {
    id: "scheduleDetails.connectedTrip",
    defaultMessage: "Connected Trip",
    description:
      "Text over the trip itinerary title that informs the user that this is a Connected Trip, so it has connections",
  },
  oneWayTrip: {
    id: "scheduleDetails.oneWayTrip",
    defaultMessage: "One-way trip",
    description:
      "Text over the trip itinerary title that informs the user that this is a one way Trip, so it has not connections and it is direct",
  },
  multipartTripMessage: {
    id: "scheduleDetails.multipartTripMessage",
    defaultMessage:
      "This trip has multiple operators or transport types – you will need to buy separate tickets.",
    description:
      "Text that informs the user that this is a multipart trip and they will need to buy separate tickets",
  },
  schedulesBtnLabel: {
    id: "label.scheduleDate",
    description: "The label above a travel date picker",
    defaultMessage: "Travel date",
  },
  select: {
    defaultMessage: "Select",
    id: "scheduleDetails.select",
    description: "Text on the button that selects this journey",
  },
  tripUiHeading: {
    id: "scheduleDetails.tripSummary",
    defaultMessage: "Trip Summary",
    description: "The heading for the redesigned schedule detail screen",
  },
  chooseDates: {
    id: "scheduleDetails.chooseDates",
    defaultMessage: "Choose dates",
    description:
      "Message displayed at top of component prompting the users to select a date.",
  },
});

export default messages;
